import React from 'react';
import GuestCard, { Guest } from './GuestCard';
interface GuestGridProps {
  guests: Guest[];
}
const GuestGrid = ({
  guests
}: GuestGridProps) => {
  return <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-2 md:gap-4" data-id="element-33">
      {guests.map((guest, index) => <GuestCard key={index} guest={guest} data-id="element-34" />)}
    </div>;
};
export default GuestGrid;